import type { NodeDefinition } from '@/types/api/nodeDefinition';

type UnverifiedModelTermsLinks = {
  termsUrl?: string;
  privacyPolicyUrl?: string;
  additionalTermsLink?: string;
};

export const getNodeTypeDisplayName = (data: unknown): string | undefined => {
  if (!data || typeof data !== 'object') return undefined;
  const displayName = (data as { displayName?: unknown }).displayName;
  return typeof displayName === 'string' ? displayName : undefined;
};

export const getModelNameDisplay = (nodeTypes: NodeDefinition[]) =>
  nodeTypes.reduce((acc, nt) => {
    const modelFromNode = nt.data.model;
    let name = '';
    if (nt.data.version === 2) {
      // TODO: this is for imported models. On new architecture - use new properties
      name = nt.data.model?.name || 'NA';
    } else {
      name = getNodeTypeDisplayName(nt.data) || nt.data?.name || modelFromNode?.name || 'NA';
    }
    return acc + (acc ? '/' : '') + name;
  }, '');

export const getTermsLinks = (nodeType: NodeDefinition) => nodeType.metadata?.termsUrls || [];

export const getPrivacyPolicyUrl = (nodeType: NodeDefinition) => nodeType.metadata?.privacyPolicyUrl || '';

export const getUnverifiedModelRunDialogInfoFromNodeTypes = ({
  nodeTypes,
  model,
}: {
  nodeTypes: NodeDefinition[];
  model: { id: string };
}): { modelsNameDisplay: string; termsLinks: UnverifiedModelTermsLinks } => {
  let modelsNameDisplay = '';
  let termsUrls: string[] = [];
  let privacyPolicyUrl = '';

  const matchingNodeTypes = nodeTypes.filter((nodeType) => nodeType.data?.model?.name === model.id);
  if (matchingNodeTypes.length) {
    modelsNameDisplay = getModelNameDisplay(matchingNodeTypes);
    const firstMatchingNodeType = matchingNodeTypes[0];
    if (firstMatchingNodeType) {
      // terms are the same for all nodes with the same model
      termsUrls = getTermsLinks(firstMatchingNodeType);
      privacyPolicyUrl = getPrivacyPolicyUrl(firstMatchingNodeType);
    }
  } else {
    // imported models
    modelsNameDisplay = model.id;
  }

  const termsLinks: UnverifiedModelTermsLinks = {
    termsUrl: termsUrls?.[0],
    privacyPolicyUrl,
    additionalTermsLink: termsUrls?.[1],
  };

  return { modelsNameDisplay, termsLinks };
};
